export enum LayoutMenuActions {
  PROFILE = 'profile',
  USERS = 'users',
  CHANGE_MENU_SELECT = 'changeSelect',
  SHOW_MENU = 'showMenu',
  SIGN_OUT = 'signOut',
}
